var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2306_86516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0V48H48V0Z",
    fill: "#FCEBE3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2306_86516)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2306_86516)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.168 17.6668L29.0013 9.8335L34.5013 13.9168L32.5013 17.7502L22.168 17.6668Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 17.6614L23.3425 9.521L31.0832 12.4409L27.6527 17.7499L20 17.6614Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 21.3335H10V24.3335H11V21.3335Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8359 18.0002L28.5026 9.16688C28.5859 9.00021 28.8359 9.00021 29.0026 9.08355L35.2526 13.7502C35.4193 13.8335 35.4193 14.0835 35.3359 14.2502L32.5026 17.8335C32.4193 17.9169 32.3359 18.0002 32.2526 18.0002H31.5026L33.1693 15.7502C32.2526 15.0835 32.0026 13.7502 32.7526 12.7502L30.5859 11.0835C30.4193 11.0002 30.2526 11.0002 30.1693 11.1669C29.5859 11.6669 28.7526 11.8335 28.0859 11.5002C27.9193 11.4169 27.7526 11.4169 27.6693 11.5835L22.9193 17.9169C22.8359 18.0002 22.7526 18.0835 22.6693 18.0835H21.8359V18.0002Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1693 18C25.1693 17.8333 25.1693 17.6667 25.2526 17.5L24.8359 17.1667L25.1693 16.75L25.5859 17.0833C25.7526 16.9167 26.0026 16.8333 26.1693 16.8333C26.4193 16.8333 26.6693 16.9167 26.8359 17.0833C26.8359 17.0833 26.8359 17.0833 26.9193 17.1667L26.5859 17.5833C26.5026 17.5 26.3359 17.5 26.2526 17.5C26.1693 17.5 26.0026 17.5833 25.9193 17.6667C25.8359 17.8333 25.7526 17.9167 25.8359 18.0833H27.1693L27.3359 18C27.5859 17.9167 27.7526 17.9167 27.9193 18C28.0026 18 28.0026 18.0833 28.0859 18.0833H29.5026C29.4193 17.4167 29.0859 16.8333 28.5026 16.3333C27.3359 15.5 25.6693 15.6667 24.8359 16.8333C24.5859 17.1667 24.4193 17.5833 24.3359 18H25.1693Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.418 37.8335H17.918V38.5835C17.918 38.8335 17.668 39.0835 17.418 39.0835H13.918C13.668 39.0835 13.418 38.8335 13.418 38.5835V37.8335Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.418 16.5833L20.0846 16.6667C19.918 17.25 19.418 17.75 19.3346 18H13.5013H13.2513V18.25V36.25V36.5H13.5013H37.5013H37.7513V36.25V18.25V18H37.5013H32.3372C33.3372 16.6667 33.1068 16.9948 33.543 16.5H36.918C38.0013 16.5 38.918 17.4167 38.918 18.5V35.6667C38.918 36.9167 37.918 37.9167 36.668 37.9167H12.418C11.3346 37.9167 10.418 37 10.418 35.9167V33.6667H11.5013V29.5H10.418V24.9167H11.5013V20.75H10.418V18.5833C10.418 17.4167 11.2513 16.5833 12.418 16.5833Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8294 20.9995V23.1662C29.6628 23.1662 29.5794 23.1662 29.4128 23.1662C29.2461 23.1662 29.0794 23.1662 28.9961 23.1662V20.9995C28.9961 20.4162 29.8294 20.4162 29.8294 20.9995Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1667 18.5H13.75V36H37.1667V18.5Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.418 37.834H35.918V38.584C35.918 38.834 35.668 39.084 35.418 39.084H31.918C31.668 39.084 31.418 38.834 31.418 38.584V37.834Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 30.0835H10V33.0835H11V30.0835Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5013 30.8338L31.668 29.7505C31.7513 29.6672 31.8346 29.5005 31.918 29.4172C32.0013 29.2505 32.0846 29.1672 32.0846 29.0005L33.918 30.0838C34.418 30.4172 34.0013 31.1672 33.5013 30.8338Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4167 23.5835C31.5 23.5835 33.0833 25.2502 33.0833 27.2502C33.0833 29.2502 31.4167 30.9168 29.4167 30.9168C27.4167 30.9168 25.75 29.2502 25.75 27.2502C25.75 25.2502 27.4167 23.5835 29.4167 23.5835Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4154 24.9165C30.7487 24.9165 31.7487 25.9998 31.7487 27.2498C31.7487 28.5832 30.6654 29.5832 29.4154 29.5832C28.082 29.5832 27.082 28.4998 27.082 27.2498C27.082 25.9165 28.082 24.9165 29.4154 24.9165Z",
    fill: "#F78670"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.918 24.8008L32.0846 25.8841C32.0013 25.7175 32.0013 25.6341 31.918 25.4675C31.8346 25.3008 31.7513 25.2175 31.668 25.1341L33.5013 24.0508C34.0013 23.8008 34.418 24.5508 33.918 24.8008Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7478 24.0508L26.5812 25.1341C26.4978 25.2175 26.4145 25.3841 26.3312 25.4675C26.2478 25.6341 26.1645 25.7175 26.1645 25.8841L24.3312 24.8008C23.8312 24.5508 24.2478 23.8008 24.7478 24.0508Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4171 30.0828L26.2504 28.9995C26.3338 29.1662 26.3338 29.2495 26.4171 29.4162C26.5004 29.5828 26.5838 29.6662 26.6671 29.7495L24.8338 30.8328C24.3338 31.1662 23.9171 30.4162 24.4171 30.0828Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9961 32.9987V30.832C29.1628 30.832 29.2461 30.832 29.4128 30.832C29.5794 30.832 29.7461 30.832 29.8294 30.832V32.9987C29.8294 33.582 28.9961 33.582 28.9961 32.9987Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8294 21.501V23.6676C29.6628 23.6676 29.5794 23.6676 29.4128 23.6676C29.2461 23.6676 29.0794 23.6676 28.9961 23.6676V21.501C28.9961 20.9176 29.8294 20.9176 29.8294 21.501Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2513 18.0005H36.7513C37.168 18.0005 37.5846 18.3338 37.5846 18.8338V35.5005C37.5846 35.9172 37.2513 36.3338 36.7513 36.3338H14.2513C13.8346 36.3338 13.418 36.0005 13.418 35.5005V18.8338C13.5013 18.4172 13.8346 18.0005 14.2513 18.0005Z",
    stroke: "#F78670",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4141 17.3091L22.9141 9.40144C22.9974 9.24789 23.1641 9.17112 23.3307 9.24789L27.3307 10.7834L26.8307 11.3208L25.3307 10.7834C25.1641 10.7066 24.9974 10.7834 24.9141 10.9369C24.4974 11.5511 23.7474 11.8582 22.9974 11.7047C22.8307 11.7047 22.6641 11.7047 22.6641 11.8582L20.2474 17.3091L20.1641 17.3859H19.4141V17.3091Z",
    fill: "#02475E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 21H11.0833C11.1667 21 11.25 21.0833 11.25 21.1667V24.5C11.25 24.5833 11.1667 24.6667 11.0833 24.6667H10",
    stroke: "#02475E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 29.75H11.0833C11.1667 29.75 11.25 29.8333 11.25 29.9167V33.25C11.25 33.3333 11.1667 33.4167 11.0833 33.4167H10",
    stroke: "#02475E",
    strokeMiterlimit: 10
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2306_86516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2306_86516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(4 4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2306_86516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.9167,
    height: 30.0833,
    fill: "white",
    transform: "translate(10 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCis);
export default __webpack_public_path__ + "static/media/cis.e2f34c44b3733e048dbe8704416fdd02.svg";
export { ForwardRef as ReactComponent };